<template>
    <svg class="icon" :style="{ fill: gradient ? `url('#${color}')` : color }" :width="width" :height="height">
        <defs>
            <linearGradient id="primaryGradient">
                <stop offset="0" stop-color="#d93fff"/>
                <stop offset="1" stop-color="#5e01ff"/>
            </linearGradient>
        </defs>
        <use :xlink:href="`#icon-${icon}`" />
    </svg>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Icon',
    props: {
        icon: {
            type: String,
            required: true
        },
        color: {
            type: String,
            default: 'currentColor'
        },
        width: {
            type: Number,
            default: 16
        },
        height: {
            type: Number,
            default: 16
        },
        gradient: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState('scssVariables', {
            styles: state => state
        })
    }
}
</script>

<style>
svg.icon {
    vertical-align: middle;
    padding: 0;
    display: inline-block;
}
</style>
